import { useContext } from 'react';
import { AuthContext, AuthContextType } from '../contexts/auth.context';

export const useAuthContext = (): AuthContextType => useContext<AuthContextType>(AuthContext);
